import type { Opportunity } from '@/types/Opportunity'

import { useOppListingOpportunities } from '../opportunities/hooks'
import {
  useOppListingActions,
  useOppListingState,
} from '../opportunities/OppListingContextProvider'
import { OppPanel } from './OppPanel'

type Props = {
  opportunities?: Opportunity[]
}

export const OppListPanel = ({ opportunities }: Props) => {
  const { activeId, oppPanelTab, isOppPanelOpen } = useOppListingState()
  const { setOppPanelOpen, setOppPanelTab } = useOppListingActions()
  const storeOppQuery = useOppListingOpportunities()
  const opps = opportunities ?? storeOppQuery.data ?? []
  const opportunity = activeId
    ? opps.find(o => o.loadId === activeId)
    : undefined

  return (
    <>
      {isOppPanelOpen && (
        <button
          aria-label="Close panel"
          className="fixed inset-0 z-40 hidden bg-black/30 b1000:block"
          onClick={() => setOppPanelOpen(false)}
          type="button"
        />
      )}

      <OppPanel
        currentTab={oppPanelTab}
        isOpen={!!isOppPanelOpen}
        opportunity={opportunity}
        onTabChange={setOppPanelTab}
      />
    </>
  )
}
